import { z } from 'zod';
/**
 * Chests (ADR 0021). The client names a chest and nothing else: the server
 * knows where the player stands, the camp around it, and what they opened.
 */
const ChestIdSchema = z.string().min(1).max(32);
export const OpenChestMessageSchema = z.object({ chestId: ChestIdSchema });
export const CHEST_STATES = ['locked', 'ready', 'opened'];
/** To one player: how the zone's chests look to them, on joining and after each change. */
export const ChestsEventSchema = z.object({
    chests: z.array(z.object({ id: ChestIdSchema, state: z.enum(CHEST_STATES) })),
});
/** To the opener: what fell out of it, on the ground in front, to be picked up. */
export const ChestOpenedSchema = z.object({
    chestId: ChestIdSchema,
    items: z.array(z.object({ templateId: z.string(), quantity: z.number().int().min(1) })),
});
export const CHEST_REFUSALS = [
    'invalid',
    'unknown-chest',
    'too-far',
    'dead',
    'locked',
    'opened',
];
export const ChestRejectedSchema = z.object({
    chestId: ChestIdSchema.optional(),
    reason: z.enum(CHEST_REFUSALS),
});
//# sourceMappingURL=chest.js.map